import React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import stepController from '../../controllers/stepcontroller';
import userController from '../../controllers/usercontroller';

const Sidebar = (props) => {
    const { t } = useTranslation();
    const id = localStorage.getItem('id');
    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });
    
    const [step0, setStep0] = useState({
        start: false,
    });
    
    const [step1, setStep1] = useState({
        start: false,
    });
    
    const [step2, setStep2] = useState({
        start: false,
    });
    
    const [step3, setStep3] = useState({
        start: false,
    });
    
    const [step4, setStep4] = useState({
        start: false,
    });
    
    const [step5, setStep5] = useState({
        start: false,
    });
    
    const [step6, setStep6] = useState({
        start: false,
    });
    
    const [step7, setStep7] = useState({
        start: false,
    });
    
    const [step8, setStep8] = useState({
        start: false,
    });

    const [status, setStatus] = useState({
        submitted: true,
    });

    const getStepDetails = async (id) => {
        await userController.getUserDetails(id, 'users').then((value)=>{
            if(value != null){
                step0.start = true;
                setStep0(step0);
            }
        });
        await stepController.getStepDetails(id, 'step1').then((value)=>{
            if(value != null){
                step1.start = true;
                setStep1(step1);
            }
        });
        await stepController.getStepDetails(id, 'step2').then((value)=>{
            if(value != null){
                step2.start = true;
                setStep2(step2);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
        await stepController.getStepDetails(id, 'step3').then((value)=>{
            if(value != null){
                step3.start = true;
                setStep3(step3);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
        await stepController.getStepDetails(id, 'step4').then((value)=>{
            if(value != null){
                step4.start = true;
                setStep4(step4);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
        await stepController.getStepDetails(id, 'step5').then((value)=>{
            if(value != null){
                step5.start = true;
                setStep5(step5);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
        await stepController.getStepDetails(id, 'step6').then((value)=>{
            if(value != null){
                step6.start = true;
                setStep6(step6);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
        await stepController.getStepDetails(id, 'step7').then((value)=>{
            if(value != null){
                step7.start = true;
                setStep7(step7);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
        await stepController.getStepDetails(id, 'step8').then((value)=>{
            if(value != null){
                step8.start = true;
                setStep8(step8);
            }
            else{
                status.submitted = false;
                setStatus(status);
            }
        });
    };

    useEffect(() => {
        if(firstRender){
            getStepDetails(id).then((data)=>{
                setFirstRender(false);
            });
            
        }
  }, [])


    return (
        <div>
            <div className="m-3 mt-0 mb-0">
                <a href="/step0" className='sidebar_menu_start'>
                    <div className="row justify-conter-between">
                        <p className="col-md-10">{t('menu_0')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                </a>
                {
                    step0.start ?
                    <a href="/step1" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_1')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                    :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_1')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step1.start ?
                    <a href="/step2" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_2')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_2')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step2.start ?
                    <a href="/step3" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_3')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_3')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step3.start ? 
                    <a href="/step4" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_4')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_4')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step4.start ?
                    <a href="/step5" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_5')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_5')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step5.start ?
                    <a href="/step6" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_6')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_6')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step6.start ?
                    <a href="/step7" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_7')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_7')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    step7.start ?
                    <a href="/step8" className='sidebar_menu_start'>
                        <div className="row justify-conter-between ">
                            <p className="col-md-10">{t('menu_8')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_8')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
                {
                    status.submitted ?
                        <a href="/step9" className='sidebar_menu_start'>
                        <div className="row justify-conter-between">
                            <p className="col-md-10">{t('menu_9')}</p>
                            <i className="col-md-1 fa fa-arrow-right me-2"></i>
                        </div>
                    </a>
                :
                    <div className="row justify-conter-between sidebar_menu">
                        <p className="col-md-10">{t('menu_9')}</p>
                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                    </div>
                }
            </div>
        </div>
    );
}

export default Sidebar;